import { RecipientSubTypeEnum } from "../../common/enums/RecipientSubTypeEnum";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import i18n from "../../services/localization-service/i18n";
import { BaseActions, ActionMenuItem  } from "../action-menu/ActionMenuItem";
import { AddIcon } from "../action-menu/ActionMenuIcons";

export interface IFormRecipient {
    id: number;
    recipientType: RecipientTypeEnum;
    recipientSubType?: RecipientSubTypeEnum;
    to: string;
    organizationID: number;

    selected?: boolean;
}

export interface IFormUserRecipient {
    userID: number;
    userName: string;

    recipients: IFormRecipient[]

    expanded?: boolean;
    disabled?: boolean;

}


export type RecipientsFormType = {

    userRecipients: IFormUserRecipient[];
};



export enum FormRecipientActions  {
    Add = 'add',
    Edit = 'edit'
}

export type FormRecipientActionItem = {
    action: FormRecipientActions | BaseActions | string
} & ActionMenuItem;

export const recipientActionItems: FormRecipientActionItem[] = [{
    label: i18n.t("buttons.newRecipient"),
    icon: AddIcon,
    action: FormRecipientActions.Add,
    order: 0
}];
